import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { LoadRecaptcha } from '@thd-olt-component-react/soe-form';
import PageForm from '../../pages/PageForm';

export const NationalForm = () => {
  return (
    <QueryProvider cacheKey="national-form">
      <LoadRecaptcha />
      <PageForm />
    </QueryProvider>
  );
};

export default NationalForm;